// /* about us video slider section js start */
// function videoSlider() {
// var slideWrapper = $(".video-main-slider"),
//   iframes = slideWrapper.find(".embed-player"),
//   lazyImages = slideWrapper.find(".slide-image"),
//   lazyCounter = 0;

// // POST commands to YouTube or Vimeo API
// function postMessageToPlayer(player, command) {
//   if (player == null || command == null) return;
//   player.contentWindow.postMessage(JSON.stringify(command), "*");
// }

// // When the slide is changing
// function playPauseVideo(slick, control) {
//   var currentSlide, slideType, startTime, player, video;

//   currentSlide = slick.find(".slick-current");
//   slideType = currentSlide.attr("class").split(" ")[1];
//   player = currentSlide.find("iframe").get(0);
//   startTime = currentSlide.data("video-start");

//   if (slideType === "vimeo") {
//     switch (control) {
//       case "play":
//         if (
//           startTime != null &&
//           startTime > 0 &&
//           !currentSlide.hasClass("started")
//         ) {
//           currentSlide.addClass("started");
//           postMessageToPlayer(player, {
//             method: "setCurrentTime",
//             value: startTime
//           });
//         }
//         postMessageToPlayer(player, {
//           method: "play",
//           value: 1
//         });
//         break;
//       case "pause":
//         postMessageToPlayer(player, {
//           method: "pause",
//           value: 1
//         });
//         break;
//     }
//   } else if (slideType === "youtube") {
//     switch (control) {
//       case "play":
//         postMessageToPlayer(player, {
//           event: "command",
//           func: "mute"
//         });
//         postMessageToPlayer(player, {
//           event: "command",
//           func: "playVideo"
//         });
//         break;
//       case "pause":
//         postMessageToPlayer(player, {
//           event: "command",
//           func: "pauseVideo"
//         });
//         break;
//     }
//   } else if (slideType === "video") {
//     video = currentSlide.children("video").get(0);
//     if (video != null) {
//       if (control === "play") {
//         video.play();
//       } else {
//         video.pause();
//       }
//     }
//   }
// }

// // DOM Ready
// $(function () {
//   // Initialize
//   slideWrapper.on("init", function (slick) {
//     slick = $(slick.currentTarget);
//     setTimeout(function () {
//       playPauseVideo(slick, "play");
//     }, 1000);
//     //resizePlayer(iframes, 16/9);
//   });
//   slideWrapper.on("beforeChange", function (event, slick) {
//     slick = $(slick.$slider);
//     playPauseVideo(slick, "pause");
//   });
//   slideWrapper.on("afterChange", function (event, slick) {
//     slick = $(slick.$slider);
//     playPauseVideo(slick, "play");
//   });
//   slideWrapper.on("lazyLoaded", function (event, slick, image, imageSource) {
//     lazyCounter++;
//     if (lazyCounter === lazyImages.length) {
//       lazyImages.addClass("show");
//       // slideWrapper.slick("slickPlay");
//     }
//   });

//   //start the slider
//   slideWrapper.slick({
//     //fade:true,
//     infinite: true,
//     //slidesToShow: 1,
//     //slidesToScroll: 1,
//     autoplaySpeed: 15000,
//     autoplay: false,
//     centerMode: false,
//     variableWidth: false,
//     lazyLoad: "progressive",
//     speed: 400,
//     arrows: true,
//     dots: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,    
//     responsive: [
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 640,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 2
//         }
//       }
//     ],

//   cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)"
    
//   });
// });
// }
// /* about us video slider section js end */
// $(document).ready(function(){
//   $(document).on("click", ".tab_block_main ul li a", function (e) {
//     var curTabContentId = $(this).attr("href");
//     $(this).parents(".tab_block_main").find("ul li a").removeClass("active");
//     $(this).addClass("active");
//     $(this)
//       .parents(".tab_block_main")
//       .find(".tab_content .tab_block")
//       .removeClass("active");
//     $(curTabContentId).addClass("active");
//     e.preventDefault();
//   });
  
// });
// var channelID = "UCZkl3XbSaIs-0yGR0qcEy-w";
// $.getJSON('https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.youtube.com%2Ffeeds%2Fvideos.xml%3Fchannel_id%3D' + channelID, function (data) {
// // change the number how many video you want from your feed
//     for (i = 0; i < 9; i++) {
//         var title = data.items[i].title;
//         var link = data.items[i].link;
//         var id = link.substr(link.indexOf("=") + 1);
//         jQuery('.youtube-container').append('<div class="item youtube"><iframe class="yt_video" src="https://youtube.com/embed/' + id + '?controls=1&showinfo=0&rel=0" width="560" height="320" frameborder="0" allowfullscreen></iframe></div>');
//         if(i == 8){
//           videoSlider();
//         }
//     }
// });



(function () {
  function initTypingPlaceholder(input) {
    if (!input || input.dataset.typingPlaceholderInit === "1") return;
    input.dataset.typingPlaceholderInit = "1";

    const words = (input.getAttribute('data-typing-placeholders') || 'PTT,Charger,Radios')
      .split(',')
      .map(w => w.trim())
      .filter(Boolean);

    if (!words.length) return;

    const typeSpeed = Number(input.getAttribute('data-type-speed')) || 80;     // typing speed
    const deleteSpeed = Number(input.getAttribute('data-delete-speed')) || 45; // deleting speed
    const holdDelay = Number(input.getAttribute('data-hold-delay')) || 900;    // pause after word

    let wordIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = null;

    function tick() {
      // If user is interacting, don't fight them
      const isFocused = document.activeElement === input;
      const hasValue = (input.value || "").length > 0;

      if (isFocused || hasValue) {
        timer = setTimeout(tick, 300);
        return;
      }

      const currentWord = words[wordIndex] || '';
      let text = currentWord.slice(0, charIndex);

      input.setAttribute('placeholder', 'Search for ' + text);

      if (!deleting) {
        if (charIndex < currentWord.length) {
          charIndex++;
          timer = setTimeout(tick, typeSpeed);
        } else {
          deleting = true;
          timer = setTimeout(tick, holdDelay);
        }
      } else {
        if (charIndex > 0) {
          charIndex--;
          timer = setTimeout(tick, deleteSpeed);
        } else {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          timer = setTimeout(tick, 250);
        }
      }
    }

    // Start
    tick();

    // If predictive search replaces header/search DOM, re-init safely
    const mo = new MutationObserver(() => {
      if (!document.contains(input)) {
        clearTimeout(timer);
        mo.disconnect();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    // Dawn header search input usually has these classes
    const input =
      document.querySelector('header .search__input.field__input') ||
      document.querySelector('header .search__input') ||
      document.querySelector('header input[type="search"][name="q"]');

    if (input) initTypingPlaceholder(input);
  }

  document.addEventListener('DOMContentLoaded', boot);

  // If theme swaps sections / re-renders header (some apps do), try again:
  document.addEventListener('shopify:section:load', boot);
})();


document.addEventListener('DOMContentLoaded', function () {
  const searchModal = document.querySelector('.custom_search-modal');
  const mobileCartInfo = document.querySelector('.cart_info_custom_mobile');

  if (!searchModal || !mobileCartInfo) return;

  const originalParent = searchModal.parentNode;
  const originalNextSibling = searchModal.nextElementSibling;

  function handleResize() {
    if (window.innerWidth < 768) {
      // 767px and below → move inside mobile cart info
      if (!mobileCartInfo.contains(searchModal)) {
        mobileCartInfo.appendChild(searchModal);
      }
    } else {
      // Desktop → restore original position
      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(searchModal, originalNextSibling);
      } else {
        originalParent.appendChild(searchModal);
      }
    }
  }

  // Initial run
  handleResize();

  // On resize
  window.addEventListener('resize', handleResize);
});

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.warranty_popup_overlay');
  if (!popup) return;

  // Append to body if not already there
  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }
});
